import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CustomTranslateService {
   languageUpdate$ = new Subject<string>();
}
